import React from 'react';
import styled from 'styled-components'
import { BrowserRouter } from 'react-router-dom'
import { ProtectedRoutes } from './Routes/ProtectedRoutes'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { theme } from '../healtheraComponents'
import SnackbarProvider from './SnackbarProvider/SnackbarProvider'
import QueryClientProvider from './QueryClientProvider/QueryClientProvider';

window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true

function App() {
  return (
    <QueryClientProvider>
      <MuiThemeProvider theme={theme}>
        <Container center="xs" middle="xs">
          <BrowserRouter>
            <SnackbarProvider>
              <ProtectedRoutes />
            </SnackbarProvider>
          </BrowserRouter>
        </Container>
      </MuiThemeProvider>
    </QueryClientProvider>
  );
}

export default App

// Styled Components
const Container = styled.section`
  margin:0 auto;
  filter: ${props => props.blur ? 'blur(8px)' : 'none'}`
